/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  BulkMessageRequest,
  CredentialPresentation,
  Customer,
  CustomerFinePrints,
  CustomerShort,
  CustomerStatus,
  Imprint,
  Invoice,
  KeycloakEventLogin,
  Message,
  Order,
  Organisation,
  Role,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    BulkMessageRequestFromJSON,
    BulkMessageRequestToJSON,
    CredentialPresentationFromJSON,
    CredentialPresentationToJSON,
    CustomerFromJSON,
    CustomerToJSON,
    CustomerFinePrintsFromJSON,
    CustomerFinePrintsToJSON,
    CustomerShortFromJSON,
    CustomerShortToJSON,
    CustomerStatusFromJSON,
    CustomerStatusToJSON,
    ImprintFromJSON,
    ImprintToJSON,
    InvoiceFromJSON,
    InvoiceToJSON,
    KeycloakEventLoginFromJSON,
    KeycloakEventLoginToJSON,
    MessageFromJSON,
    MessageToJSON,
    OrderFromJSON,
    OrderToJSON,
    OrganisationFromJSON,
    OrganisationToJSON,
    RoleFromJSON,
    RoleToJSON,
} from '../models';

export interface AddMessageForCustomerByIdRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    message: Message;
}

export interface DeleteCustomerRequest {
    xApplicationScope: ApplicationScope;
}

export interface DeleteCustomerDataPrivacyPdfRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
}

export interface DeleteCustomerImageRequest {
    xApplicationScope: ApplicationScope;
}

export interface DeleteCustomerIrreversibleAsUserRequest {
    xApplicationScope: ApplicationScope;
}

export interface DeleteCustomerTermsUsagePdfRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
}

export interface DeleteMessageForCurrentCustomerRequest {
    xApplicationScope: ApplicationScope;
    message: Message;
}

export interface DeleteMessageForCustomerByIdRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    message: Message;
}

export interface DeleteOtherCustomerIrreversibleAsSuperadminRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface FinishCustomerRegistrationForKeycloakRequest {
    xApplicationScope: ApplicationScope;
    organisation: Organisation;
}

export interface GetCurrentOrdersRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetCustomerRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetCustomerAllowedApplicationsRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetCustomerByIdRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface GetCustomerDataPrivacyPdfRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
}

export interface GetCustomerFinePrintsRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
}

export interface GetCustomerImageRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetCustomerImageByUsernameRequest {
    xApplicationScope: ApplicationScope;
    username: string;
}

export interface GetCustomerImprintRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
}

export interface GetCustomerRolesRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface GetCustomerStatusRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetCustomerStatusByIdRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface GetCustomerTermsUsagePdfRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
}

export interface GetCustomersRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetInvoicesByCustomerRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
}

export interface GetMessagesForCurrentCustomerRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetMessagesForCustomerByIdRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface GetOrdersByCustomerRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface GetUserKeycloakEventLoginRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
}

export interface GetUsersAsExcelRequest {
    xApplicationScope: ApplicationScope;
}

export interface LockCustomerRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface MarkCustomerFreeOfChargeRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface PartiallyUpdateCustomerRequest {
    xApplicationScope: ApplicationScope;
    customer: Customer;
}

export interface PartiallyUpdateCustomerByIdRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    customer: Customer;
}

export interface QueryCustomersByQueryObjectRequest {
    xApplicationScope: ApplicationScope;
    customer: Customer;
}

export interface ResetKeycloakPasswordRequest {
    xApplicationScope: ApplicationScope;
    credentialPresentation: CredentialPresentation;
}

export interface ResetKeycloakPasswordForOtherUserRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
}

export interface SendMessageToMultipleRecipientsRequest {
    xApplicationScope: ApplicationScope;
    bulkMessageRequest: BulkMessageRequest;
}

export interface UnlockCustomerRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface UnmarkCustomerFreeOfChargeRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface UpdateCustomerRequest {
    xApplicationScope: ApplicationScope;
    customer: Customer;
}

export interface UpdateCustomerDataPrivacyPdfRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
    filename: string;
    body: Blob;
}

export interface UpdateCustomerDeactivationOrDeletionNotificationDateRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    customer: Customer;
}

export interface UpdateCustomerImageRequest {
    xApplicationScope: ApplicationScope;
    body: Blob;
}

export interface UpdateCustomerImprintRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
    imprint: Imprint;
}

export interface UpdateCustomerReferenceByIdRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    customer: Customer;
}

export interface UpdateCustomerRolesRequest {
    xApplicationScope: ApplicationScope;
    id: string;
    role: Array<Role>;
}

export interface UpdateCustomerTermsUsagePdfRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
    filename: string;
    body: Blob;
}

/**
 * 
 */
export class CustomerControllerApi extends runtime.BaseAPI {

    /**
     * add message for customer by id
     * add message for customer by id
     */
    async addMessageForCustomerByIdRaw(requestParameters: AddMessageForCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Message>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling addMessageForCustomerById.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling addMessageForCustomerById.');
        }

        if (requestParameters.message === null || requestParameters.message === undefined) {
            throw new runtime.RequiredError('message','Required parameter requestParameters.message was null or undefined when calling addMessageForCustomerById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/messages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MessageToJSON(requestParameters.message),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * add message for customer by id
     * add message for customer by id
     */
    async addMessageForCustomerById(requestParameters: AddMessageForCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Message> {
        const response = await this.addMessageForCustomerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete current customer
     * delete current customer
     */
    async deleteCustomerRaw(requestParameters: DeleteCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete current customer
     * delete current customer
     */
    async deleteCustomer(requestParameters: DeleteCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomerRaw(requestParameters, initOverrides);
    }

    /**
     * delete customer data privacy pdf
     * delete customer data privacy pdf
     */
    async deleteCustomerDataPrivacyPdfRaw(requestParameters: DeleteCustomerDataPrivacyPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteCustomerDataPrivacyPdf.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling deleteCustomerDataPrivacyPdf.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/document/{customerId}/data-privacy`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete customer data privacy pdf
     * delete customer data privacy pdf
     */
    async deleteCustomerDataPrivacyPdf(requestParameters: DeleteCustomerDataPrivacyPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomerDataPrivacyPdfRaw(requestParameters, initOverrides);
    }

    /**
     * delete customer image
     * delete customer image
     */
    async deleteCustomerImageRaw(requestParameters: DeleteCustomerImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteCustomerImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current/image`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete customer image
     * delete customer image
     */
    async deleteCustomerImage(requestParameters: DeleteCustomerImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomerImageRaw(requestParameters, initOverrides);
    }

    /**
     * delete current customer
     * delete current customer
     */
    async deleteCustomerIrreversibleAsUserRaw(requestParameters: DeleteCustomerIrreversibleAsUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteCustomerIrreversibleAsUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current/irreversible`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete current customer
     * delete current customer
     */
    async deleteCustomerIrreversibleAsUser(requestParameters: DeleteCustomerIrreversibleAsUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomerIrreversibleAsUserRaw(requestParameters, initOverrides);
    }

    /**
     * delete customer terms usage pdf
     * delete customer terms usage pdf
     */
    async deleteCustomerTermsUsagePdfRaw(requestParameters: DeleteCustomerTermsUsagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteCustomerTermsUsagePdf.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling deleteCustomerTermsUsagePdf.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/document/{customerId}/terms-usage`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete customer terms usage pdf
     * delete customer terms usage pdf
     */
    async deleteCustomerTermsUsagePdf(requestParameters: DeleteCustomerTermsUsagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomerTermsUsagePdfRaw(requestParameters, initOverrides);
    }

    /**
     * delete message for current customer
     * delete message for current customer
     */
    async deleteMessageForCurrentCustomerRaw(requestParameters: DeleteMessageForCurrentCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteMessageForCurrentCustomer.');
        }

        if (requestParameters.message === null || requestParameters.message === undefined) {
            throw new runtime.RequiredError('message','Required parameter requestParameters.message was null or undefined when calling deleteMessageForCurrentCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current/messages`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: MessageToJSON(requestParameters.message),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete message for current customer
     * delete message for current customer
     */
    async deleteMessageForCurrentCustomer(requestParameters: DeleteMessageForCurrentCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMessageForCurrentCustomerRaw(requestParameters, initOverrides);
    }

    /**
     * delete message for customer by id
     * delete message for customer by id
     */
    async deleteMessageForCustomerByIdRaw(requestParameters: DeleteMessageForCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteMessageForCustomerById.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteMessageForCustomerById.');
        }

        if (requestParameters.message === null || requestParameters.message === undefined) {
            throw new runtime.RequiredError('message','Required parameter requestParameters.message was null or undefined when calling deleteMessageForCustomerById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/messages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: MessageToJSON(requestParameters.message),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete message for customer by id
     * delete message for customer by id
     */
    async deleteMessageForCustomerById(requestParameters: DeleteMessageForCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMessageForCustomerByIdRaw(requestParameters, initOverrides);
    }

    /**
     * delete customer irreversible as superadmin
     * delete customer irreversible as superadmin
     */
    async deleteOtherCustomerIrreversibleAsSuperadminRaw(requestParameters: DeleteOtherCustomerIrreversibleAsSuperadminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteOtherCustomerIrreversibleAsSuperadmin.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteOtherCustomerIrreversibleAsSuperadmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete customer irreversible as superadmin
     * delete customer irreversible as superadmin
     */
    async deleteOtherCustomerIrreversibleAsSuperadmin(requestParameters: DeleteOtherCustomerIrreversibleAsSuperadminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOtherCustomerIrreversibleAsSuperadminRaw(requestParameters, initOverrides);
    }

    /**
     * finish an ongoing customer registration that registered on keycloak server
     * finish new customer registration-for-keycloak
     */
    async finishCustomerRegistrationForKeycloakRaw(requestParameters: FinishCustomerRegistrationForKeycloakRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling finishCustomerRegistrationForKeycloak.');
        }

        if (requestParameters.organisation === null || requestParameters.organisation === undefined) {
            throw new runtime.RequiredError('organisation','Required parameter requestParameters.organisation was null or undefined when calling finishCustomerRegistrationForKeycloak.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/registration/finish`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganisationToJSON(requestParameters.organisation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * finish an ongoing customer registration that registered on keycloak server
     * finish new customer registration-for-keycloak
     */
    async finishCustomerRegistrationForKeycloak(requestParameters: FinishCustomerRegistrationForKeycloakRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.finishCustomerRegistrationForKeycloakRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get orders of current customer
     * get orders of current customer
     */
    async getCurrentOrdersRaw(requestParameters: GetCurrentOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Order>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCurrentOrders.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current/orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrderFromJSON));
    }

    /**
     * get orders of current customer
     * get orders of current customer
     */
    async getCurrentOrders(requestParameters: GetCurrentOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Order>> {
        const response = await this.getCurrentOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get current customer
     * get current customer
     */
    async getCustomerRaw(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * get current customer
     * get current customer
     */
    async getCustomer(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.getCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get current customer\'s allowed applications
     * get current customer\'s allowed applications
     */
    async getCustomerAllowedApplicationsRaw(requestParameters: GetCustomerAllowedApplicationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApplicationScope>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerAllowedApplications.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current/applications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApplicationScopeFromJSON));
    }

    /**
     * get current customer\'s allowed applications
     * get current customer\'s allowed applications
     */
    async getCustomerAllowedApplications(requestParameters: GetCustomerAllowedApplicationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApplicationScope>> {
        const response = await this.getCustomerAllowedApplicationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get customer by id
     * get customer by id
     */
    async getCustomerByIdRaw(requestParameters: GetCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerById.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getCustomerById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * get customer by id
     * get customer by id
     */
    async getCustomerById(requestParameters: GetCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.getCustomerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get customer data privacy pdf
     * get customer data privacy pdf
     */
    async getCustomerDataPrivacyPdfRaw(requestParameters: GetCustomerDataPrivacyPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerDataPrivacyPdf.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getCustomerDataPrivacyPdf.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/customers/document/{customerId}/data-privacy`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get customer data privacy pdf
     * get customer data privacy pdf
     */
    async getCustomerDataPrivacyPdf(requestParameters: GetCustomerDataPrivacyPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getCustomerDataPrivacyPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get customer fine prints
     * get customer fine prints
     */
    async getCustomerFinePrintsRaw(requestParameters: GetCustomerFinePrintsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerFinePrints>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerFinePrints.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getCustomerFinePrints.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/customers/document/{customerId}/fine-prints`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFinePrintsFromJSON(jsonValue));
    }

    /**
     * get customer fine prints
     * get customer fine prints
     */
    async getCustomerFinePrints(requestParameters: GetCustomerFinePrintsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerFinePrints> {
        const response = await this.getCustomerFinePrintsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get customer image
     * get customer image
     */
    async getCustomerImageRaw(requestParameters: GetCustomerImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current/image`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get customer image
     * get customer image
     */
    async getCustomerImage(requestParameters: GetCustomerImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getCustomerImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get customer image by username
     * get customer image by username
     */
    async getCustomerImageByUsernameRaw(requestParameters: GetCustomerImageByUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerImageByUsername.');
        }

        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username','Required parameter requestParameters.username was null or undefined when calling getCustomerImageByUsername.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{username}/image`.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters.username))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get customer image by username
     * get customer image by username
     */
    async getCustomerImageByUsername(requestParameters: GetCustomerImageByUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getCustomerImageByUsernameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get customer imprint
     * get customer imprint
     */
    async getCustomerImprintRaw(requestParameters: GetCustomerImprintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerImprint.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getCustomerImprint.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/customers/document/{customerId}/imprint`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * get customer imprint
     * get customer imprint
     */
    async getCustomerImprint(requestParameters: GetCustomerImprintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getCustomerImprintRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all roles of a customer
     * get all roles of a customer
     */
    async getCustomerRolesRaw(requestParameters: GetCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Role>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerRoles.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getCustomerRoles.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleFromJSON));
    }

    /**
     * get all roles of a customer
     * get all roles of a customer
     */
    async getCustomerRoles(requestParameters: GetCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Role>> {
        const response = await this.getCustomerRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get current customer\'s status
     * get current customer\'s status
     */
    async getCustomerStatusRaw(requestParameters: GetCustomerStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerStatus>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerStatusFromJSON(jsonValue));
    }

    /**
     * get current customer\'s status
     * get current customer\'s status
     */
    async getCustomerStatus(requestParameters: GetCustomerStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerStatus> {
        const response = await this.getCustomerStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get customer status by id
     * get customer status by id
     */
    async getCustomerStatusByIdRaw(requestParameters: GetCustomerStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerStatus>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerStatusById.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getCustomerStatusById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerStatusFromJSON(jsonValue));
    }

    /**
     * get customer status by id
     * get customer status by id
     */
    async getCustomerStatusById(requestParameters: GetCustomerStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerStatus> {
        const response = await this.getCustomerStatusByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get customer terms usage pdf
     * get customer terms usage pdf
     */
    async getCustomerTermsUsagePdfRaw(requestParameters: GetCustomerTermsUsagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerTermsUsagePdf.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getCustomerTermsUsagePdf.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/customers/document/{customerId}/terms-usage`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get customer terms usage pdf
     * get customer terms usage pdf
     */
    async getCustomerTermsUsagePdf(requestParameters: GetCustomerTermsUsagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getCustomerTermsUsagePdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all customers
     * get all customers
     */
    async getCustomersRaw(requestParameters: GetCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerShort>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerShortFromJSON));
    }

    /**
     * get all customers
     * get all customers
     */
    async getCustomers(requestParameters: GetCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerShort>> {
        const response = await this.getCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get invoices by customer
     * get invoices by customer
     */
    async getInvoicesByCustomerRaw(requestParameters: GetInvoicesByCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Invoice>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getInvoicesByCustomer.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getInvoicesByCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{customerId}/invoices`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceFromJSON));
    }

    /**
     * get invoices by customer
     * get invoices by customer
     */
    async getInvoicesByCustomer(requestParameters: GetInvoicesByCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Invoice>> {
        const response = await this.getInvoicesByCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get messages for current customer
     * get messages for current customer
     */
    async getMessagesForCurrentCustomerRaw(requestParameters: GetMessagesForCurrentCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Message>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getMessagesForCurrentCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current/messages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MessageFromJSON));
    }

    /**
     * get messages for current customer
     * get messages for current customer
     */
    async getMessagesForCurrentCustomer(requestParameters: GetMessagesForCurrentCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Message>> {
        const response = await this.getMessagesForCurrentCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get messages for customer by id
     * get messages for customer by id
     */
    async getMessagesForCustomerByIdRaw(requestParameters: GetMessagesForCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Message>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getMessagesForCustomerById.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getMessagesForCustomerById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/messages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MessageFromJSON));
    }

    /**
     * get messages for customer by id
     * get messages for customer by id
     */
    async getMessagesForCustomerById(requestParameters: GetMessagesForCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Message>> {
        const response = await this.getMessagesForCustomerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get orders by customer
     * get orders by customer
     */
    async getOrdersByCustomerRaw(requestParameters: GetOrdersByCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Order>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getOrdersByCustomer.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getOrdersByCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/orders`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrderFromJSON));
    }

    /**
     * get orders by customer
     * get orders by customer
     */
    async getOrdersByCustomer(requestParameters: GetOrdersByCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Order>> {
        const response = await this.getOrdersByCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get user keycloak event login
     * get user keycloak event login
     */
    async getUserKeycloakEventLoginRaw(requestParameters: GetUserKeycloakEventLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KeycloakEventLogin>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getUserKeycloakEventLogin.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getUserKeycloakEventLogin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{customerId}/loginEvent`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KeycloakEventLoginFromJSON(jsonValue));
    }

    /**
     * get user keycloak event login
     * get user keycloak event login
     */
    async getUserKeycloakEventLogin(requestParameters: GetUserKeycloakEventLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KeycloakEventLogin> {
        const response = await this.getUserKeycloakEventLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all users as excel file
     * get all users as excel file
     */
    async getUsersAsExcelRaw(requestParameters: GetUsersAsExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getUsersAsExcel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get all users as excel file
     * get all users as excel file
     */
    async getUsersAsExcel(requestParameters: GetUsersAsExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getUsersAsExcelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * lock a customer
     * lock a customer
     */
    async lockCustomerRaw(requestParameters: LockCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling lockCustomer.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling lockCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/lock`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * lock a customer
     * lock a customer
     */
    async lockCustomer(requestParameters: LockCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.lockCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * mark a customer free of charge
     * mark a customer free of charge
     */
    async markCustomerFreeOfChargeRaw(requestParameters: MarkCustomerFreeOfChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling markCustomerFreeOfCharge.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling markCustomerFreeOfCharge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/freeofcharge`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * mark a customer free of charge
     * mark a customer free of charge
     */
    async markCustomerFreeOfCharge(requestParameters: MarkCustomerFreeOfChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.markCustomerFreeOfChargeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * partially update current customer
     * partially update current customer
     */
    async partiallyUpdateCustomerRaw(requestParameters: PartiallyUpdateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling partiallyUpdateCustomer.');
        }

        if (requestParameters.customer === null || requestParameters.customer === undefined) {
            throw new runtime.RequiredError('customer','Required parameter requestParameters.customer was null or undefined when calling partiallyUpdateCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerToJSON(requestParameters.customer),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * partially update current customer
     * partially update current customer
     */
    async partiallyUpdateCustomer(requestParameters: PartiallyUpdateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.partiallyUpdateCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * partially update customer by id
     * partially update customer by id
     */
    async partiallyUpdateCustomerByIdRaw(requestParameters: PartiallyUpdateCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling partiallyUpdateCustomerById.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partiallyUpdateCustomerById.');
        }

        if (requestParameters.customer === null || requestParameters.customer === undefined) {
            throw new runtime.RequiredError('customer','Required parameter requestParameters.customer was null or undefined when calling partiallyUpdateCustomerById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerToJSON(requestParameters.customer),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * partially update customer by id
     * partially update customer by id
     */
    async partiallyUpdateCustomerById(requestParameters: PartiallyUpdateCustomerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.partiallyUpdateCustomerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * query customers by query object
     * query customers by query object
     */
    async queryCustomersByQueryObjectRaw(requestParameters: QueryCustomersByQueryObjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerShort>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling queryCustomersByQueryObject.');
        }

        if (requestParameters.customer === null || requestParameters.customer === undefined) {
            throw new runtime.RequiredError('customer','Required parameter requestParameters.customer was null or undefined when calling queryCustomersByQueryObject.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/query`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerToJSON(requestParameters.customer),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerShortFromJSON));
    }

    /**
     * query customers by query object
     * query customers by query object
     */
    async queryCustomersByQueryObject(requestParameters: QueryCustomersByQueryObjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerShort>> {
        const response = await this.queryCustomersByQueryObjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * reset password in keycloak client
     * reset keycloak password
     */
    async resetKeycloakPasswordRaw(requestParameters: ResetKeycloakPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling resetKeycloakPassword.');
        }

        if (requestParameters.credentialPresentation === null || requestParameters.credentialPresentation === undefined) {
            throw new runtime.RequiredError('credentialPresentation','Required parameter requestParameters.credentialPresentation was null or undefined when calling resetKeycloakPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/reset-password`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialPresentationToJSON(requestParameters.credentialPresentation),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * reset password in keycloak client
     * reset keycloak password
     */
    async resetKeycloakPassword(requestParameters: ResetKeycloakPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetKeycloakPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * trigger update password email for other use
     * reset keycloak password for other user
     */
    async resetKeycloakPasswordForOtherUserRaw(requestParameters: ResetKeycloakPasswordForOtherUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling resetKeycloakPasswordForOtherUser.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling resetKeycloakPasswordForOtherUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/reset-password-email/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * trigger update password email for other use
     * reset keycloak password for other user
     */
    async resetKeycloakPasswordForOtherUser(requestParameters: ResetKeycloakPasswordForOtherUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetKeycloakPasswordForOtherUserRaw(requestParameters, initOverrides);
    }

    /**
     * send message to multiple recipients
     * send message to multiple recipients
     */
    async sendMessageToMultipleRecipientsRaw(requestParameters: SendMessageToMultipleRecipientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling sendMessageToMultipleRecipients.');
        }

        if (requestParameters.bulkMessageRequest === null || requestParameters.bulkMessageRequest === undefined) {
            throw new runtime.RequiredError('bulkMessageRequest','Required parameter requestParameters.bulkMessageRequest was null or undefined when calling sendMessageToMultipleRecipients.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/messages`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkMessageRequestToJSON(requestParameters.bulkMessageRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * send message to multiple recipients
     * send message to multiple recipients
     */
    async sendMessageToMultipleRecipients(requestParameters: SendMessageToMultipleRecipientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendMessageToMultipleRecipientsRaw(requestParameters, initOverrides);
    }

    /**
     * unlock a customer
     * unlock a customer
     */
    async unlockCustomerRaw(requestParameters: UnlockCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling unlockCustomer.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unlockCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/lock`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * unlock a customer
     * unlock a customer
     */
    async unlockCustomer(requestParameters: UnlockCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.unlockCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * unmark a customer free of charge
     * unmark a customer free of charge
     */
    async unmarkCustomerFreeOfChargeRaw(requestParameters: UnmarkCustomerFreeOfChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling unmarkCustomerFreeOfCharge.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unmarkCustomerFreeOfCharge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/freeofcharge`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * unmark a customer free of charge
     * unmark a customer free of charge
     */
    async unmarkCustomerFreeOfCharge(requestParameters: UnmarkCustomerFreeOfChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.unmarkCustomerFreeOfChargeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update current customer
     * update current customer
     */
    async updateCustomerRaw(requestParameters: UpdateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCustomer.');
        }

        if (requestParameters.customer === null || requestParameters.customer === undefined) {
            throw new runtime.RequiredError('customer','Required parameter requestParameters.customer was null or undefined when calling updateCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerToJSON(requestParameters.customer),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * update current customer
     * update current customer
     */
    async updateCustomer(requestParameters: UpdateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.updateCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update customer data privacy pdf
     * update customer data privacy pdf
     */
    async updateCustomerDataPrivacyPdfRaw(requestParameters: UpdateCustomerDataPrivacyPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCustomerDataPrivacyPdf.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling updateCustomerDataPrivacyPdf.');
        }

        if (requestParameters.filename === null || requestParameters.filename === undefined) {
            throw new runtime.RequiredError('filename','Required parameter requestParameters.filename was null or undefined when calling updateCustomerDataPrivacyPdf.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling updateCustomerDataPrivacyPdf.');
        }

        const queryParameters: any = {};

        if (requestParameters.filename !== undefined) {
            queryParameters['filename'] = requestParameters.filename;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/pdf';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/document/{customerId}/data-privacy`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * update customer data privacy pdf
     * update customer data privacy pdf
     */
    async updateCustomerDataPrivacyPdf(requestParameters: UpdateCustomerDataPrivacyPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCustomerDataPrivacyPdfRaw(requestParameters, initOverrides);
    }

    /**
     * update customer deactivation or deletion notification date
     * update customer deactivation or deletion notification date
     */
    async updateCustomerDeactivationOrDeletionNotificationDateRaw(requestParameters: UpdateCustomerDeactivationOrDeletionNotificationDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerShort>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCustomerDeactivationOrDeletionNotificationDate.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateCustomerDeactivationOrDeletionNotificationDate.');
        }

        if (requestParameters.customer === null || requestParameters.customer === undefined) {
            throw new runtime.RequiredError('customer','Required parameter requestParameters.customer was null or undefined when calling updateCustomerDeactivationOrDeletionNotificationDate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/deactivation-deletion-notification-date`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerToJSON(requestParameters.customer),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerShortFromJSON(jsonValue));
    }

    /**
     * update customer deactivation or deletion notification date
     * update customer deactivation or deletion notification date
     */
    async updateCustomerDeactivationOrDeletionNotificationDate(requestParameters: UpdateCustomerDeactivationOrDeletionNotificationDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerShort> {
        const response = await this.updateCustomerDeactivationOrDeletionNotificationDateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update customer image
     * update customer image
     */
    async updateCustomerImageRaw(requestParameters: UpdateCustomerImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCustomerImage.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling updateCustomerImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'image/jpeg';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/current/image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * update customer image
     * update customer image
     */
    async updateCustomerImage(requestParameters: UpdateCustomerImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCustomerImageRaw(requestParameters, initOverrides);
    }

    /**
     * update customer imprint
     * update customer imprint
     */
    async updateCustomerImprintRaw(requestParameters: UpdateCustomerImprintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Imprint>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCustomerImprint.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling updateCustomerImprint.');
        }

        if (requestParameters.imprint === null || requestParameters.imprint === undefined) {
            throw new runtime.RequiredError('imprint','Required parameter requestParameters.imprint was null or undefined when calling updateCustomerImprint.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/document/{customerId}/imprint`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImprintToJSON(requestParameters.imprint),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImprintFromJSON(jsonValue));
    }

    /**
     * update customer imprint
     * update customer imprint
     */
    async updateCustomerImprint(requestParameters: UpdateCustomerImprintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Imprint> {
        const response = await this.updateCustomerImprintRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update customer reference by id
     * update customer reference by id
     */
    async updateCustomerReferenceByIdRaw(requestParameters: UpdateCustomerReferenceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCustomerReferenceById.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateCustomerReferenceById.');
        }

        if (requestParameters.customer === null || requestParameters.customer === undefined) {
            throw new runtime.RequiredError('customer','Required parameter requestParameters.customer was null or undefined when calling updateCustomerReferenceById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/reference`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerToJSON(requestParameters.customer),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * update customer reference by id
     * update customer reference by id
     */
    async updateCustomerReferenceById(requestParameters: UpdateCustomerReferenceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.updateCustomerReferenceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update roles of a customer
     * update roles of a customer
     */
    async updateCustomerRolesRaw(requestParameters: UpdateCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Role>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCustomerRoles.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateCustomerRoles.');
        }

        if (requestParameters.role === null || requestParameters.role === undefined) {
            throw new runtime.RequiredError('role','Required parameter requestParameters.role was null or undefined when calling updateCustomerRoles.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/{id}/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.role.map(RoleToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleFromJSON));
    }

    /**
     * update roles of a customer
     * update roles of a customer
     */
    async updateCustomerRoles(requestParameters: UpdateCustomerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Role>> {
        const response = await this.updateCustomerRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update customer terms usage pdf
     * update customer terms usage pdf
     */
    async updateCustomerTermsUsagePdfRaw(requestParameters: UpdateCustomerTermsUsagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCustomerTermsUsagePdf.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling updateCustomerTermsUsagePdf.');
        }

        if (requestParameters.filename === null || requestParameters.filename === undefined) {
            throw new runtime.RequiredError('filename','Required parameter requestParameters.filename was null or undefined when calling updateCustomerTermsUsagePdf.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling updateCustomerTermsUsagePdf.');
        }

        const queryParameters: any = {};

        if (requestParameters.filename !== undefined) {
            queryParameters['filename'] = requestParameters.filename;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/pdf';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/customers/document/{customerId}/terms-usage`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * update customer terms usage pdf
     * update customer terms usage pdf
     */
    async updateCustomerTermsUsagePdf(requestParameters: UpdateCustomerTermsUsagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCustomerTermsUsagePdfRaw(requestParameters, initOverrides);
    }

}
